import React, { useEffect, useState } from "react";
import { getAllOrders } from "../../services/api";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
  IconButton,
  Divider,
  Button,
  Popover,
  CircularProgress,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import LsService, { storageKey } from "../../services/localstorage";
import TablePagination from "@mui/material/TablePagination";
import { useNavigate } from "react-router-dom";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { AccentButton } from "../../data/functions";
import "./print.css";
import billIcon from "./varnamzzz_black1.png";
import { generateReceipt, handlePrint } from "./cashFunctions";

function Row({ order, onPrintReceipt }) {
  const [open, setOpen] = useState(false);
  // console.log(order);

  return (
    <>
      {/* Parent Row = Order */}
      <TableRow>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{order.sno}</TableCell>
        <TableCell>INV{order.invoice_number}</TableCell>
        <TableCell>
          {order.customer_name ? order.customer_name : "N/A"}
        </TableCell>
        <TableCell>
          {order.customer_phone ? order.customer_phone : "N/A"}
        </TableCell>
        <TableCell>
          {order.order_date} {order.order_time}
        </TableCell>
        <TableCell>{order.paymentMethod}</TableCell>
        <TableCell>₹{order.discount_price}</TableCell>
        <TableCell>₹{order.total}</TableCell>
        <TableCell>{order.user_name}</TableCell>
        <TableCell>
          <Button
            variant="contained"
            size="small"
            onClick={() => onPrintReceipt(order)}
          >
            Print Receipt
          </Button>
        </TableCell>
      </TableRow>

      {/* Collapsible Child Row = Cart Items */}
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom>
                Cart Items
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#506991",
                    }}
                  >
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Barcode
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Name
                    </TableCell>
                    <TableCell
                      sx={{ color: "white", fontWeight: "bold" }}
                      align="center"
                    >
                      Qty
                    </TableCell>
                    <TableCell
                      sx={{ color: "white", fontWeight: "bold" }}
                      align="right"
                    >
                      Price
                    </TableCell>
                    <TableCell
                      sx={{ color: "white", fontWeight: "bold" }}
                      align="right"
                    >
                      Item Total
                    </TableCell>

                    <TableCell
                      sx={{ color: "white", fontWeight: "bold" }}
                      align="right"
                    >
                      GST
                    </TableCell>
                    <TableCell
                      sx={{ color: "white", fontWeight: "bold" }}
                      align="center"
                    >
                      isCombo
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {order.cart?.map((item, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{item.barcode}</TableCell>
                      <TableCell>{item.name}</TableCell>
                      <TableCell align="center">{item.quantity}</TableCell>
                      <TableCell align="right">₹{item.price}</TableCell>
                      <TableCell align="right">₹{item.item_total}</TableCell>
                      <TableCell align="right">{item.gst}%</TableCell>
                      <TableCell align="center">
                        {item.is_combo === true ? "Yes" : "No"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

function CashierBillings() {
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [orderMesg, setOrderMesg] = useState("");
  const [orderErrMesg, setOrderErrMesg] = useState("");

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0); // totalUsers from backend

  const navigate = useNavigate();

  const [billIconBase64, setBillIconBase64] = useState("");

  const userLoginStatus = LsService.getItem(storageKey);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogoutClick = () => {
    LsService.removeItem(storageKey);
    navigate("/");
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    fetchStoreOrders();
  }, [paginationModel]);

  useEffect(() => {
    fetch(billIcon)
      .then((res) => res.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => setBillIconBase64(reader.result);
        reader.readAsDataURL(blob);
      });
  }, []);

  const fetchStoreOrders = async () => {
    try {
      setOrderMesg("");
      setOrderErrMesg("");
      setLoading(true);

      const response = await getAllOrders({
        page: paginationModel.page + 1, // backend is usually 1-based
        limit: paginationModel.pageSize,
      });
      // console.log(response.data);

      const apiData = response.data || {};
      const apiOrders = apiData.data || [];
      const totalUsers = apiData.totalOrders || 0;

      const mappedOrders = apiOrders.map((o, i) => {
        const orderDateObj = new Date(o.order_date);
        const orderDateStr = orderDateObj.toISOString().slice(0, 10); // YYYY-MM-DD
        const orderTimeStr = orderDateObj.toTimeString().slice(0, 5); // HH:MM

        // 🔹 GROUP PRODUCTS & COMBOS
        const productMap = new Map();
        const comboMap = new Map();

        (o.OrderProducts || []).forEach((op) => {
          // 👉 COMBO LINES
          if (op.ComboProduct) {
            const cp = op.ComboProduct;
            const comboId = cp.combo_id;
            const comboMeta = cp.Combo || {};

            // ❗ if we already processed this combo_id once, ignore duplicates
            if (comboMap.has(comboId)) return;

            const lineQty = Number(op.quantity || 0); // quantity of this combo purchased
            const comboName = comboMeta.combo_name || `Combo #${comboId}`; // use this
            const comboPrice = Number(comboMeta.combo_price || 0); // use this
            const comboGst = Number(comboMeta.combo_gst || 0); // use this

            comboMap.set(comboId, {
              combo_id: comboId,
              name: comboName,
              quantity: lineQty, // do NOT sum, just take from first row
              pricePerCombo: comboPrice,
              gst: comboGst,
            });

            return;
          }

          // 👉 NORMAL PRODUCT LINES
          const prod = Array.isArray(op.Products)
            ? op.Products[0]
            : op.Products;
          if (!prod) return;

          const prId = prod.pr_id;
          const lineQty = Number(op.quantity || 0);
          const linePrice = Number(prod.discount_price || op.price || 0);
          const gst = Number(prod.gst || 0);

          let entry = productMap.get(prId);
          if (!entry) {
            entry = {
              barcode: prod.barcode || "N/A",
              name: prod.product_name || `#${prId}`,
              quantity: 0,
              totalPrice: 0,
              gst,
            };
          }

          entry.quantity += lineQty;
          entry.totalPrice += lineQty * linePrice;

          productMap.set(prId, entry);
        });

        // 🔹 Build cart[] from both maps
        const cart = [];

        // Normal products
        productMap.forEach((p) => {
          const unitPrice = p.quantity ? p.totalPrice / p.quantity : 0;
          const total = unitPrice * p.quantity;

          cart.push({
            barcode: p.barcode,
            name: p.name,
            quantity: p.quantity,
            price: unitPrice,
            item_total: Number(total.toFixed(2)), // 👈 qty * price
            gst: p.gst,
            is_combo: false,
          });
        });

        // Combos (one row per combo_id, using first occurrence only)
        comboMap.forEach((c) => {
          const total = c.pricePerCombo * c.quantity;

          cart.push({
            barcode: "N/A",
            name: c.name, // combo_name
            quantity: c.quantity, // quantity from the first row
            price: c.pricePerCombo, // combo_price (per combo)
            item_total: Number(total.toFixed(2)), // 👈 qty * price

            gst: c.gst, // combo_gst
            is_combo: true,
          });
        });

        return {
          ...o,
          sno: i + 1,
          cart, // ✅ aggregated list used by Row & onPrintReceipt
          invoice_number: o.order_id,
          order_date: orderDateStr,
          order_time: orderTimeStr,
          paymentMethod: o.payment_method,
          total: Number(o.total_amount || 0),
          user_name: o.user_name || "Cashier",
        };
      });

      setOrders(mappedOrders);
      setOrderMesg(response.data.message);
      setRowCount(totalUsers);
    } catch (error) {
      console.error(error);
      setOrderErrMesg(
        error?.response?.data?.message || "Failed to fetch orders"
      );
    } finally {
      setLoading(false);
      setTimeout(() => {
        setOrderErrMesg("");
        setOrderMesg("");
      }, 20000);
    }
  };

  const onPrintReceipt = (order) => {
    // console.log(order);
    // Build products array for the receipt from mapped cart[]
    const products = (order.cart || []).map((item) => ({
      price: Number(item.price),
      quantity: item.quantity,
      product_name: item.name,
      gst: Number(item.gst || 0),
    }));

    // Compute total GST from items
    const totalGstPrice = products
      .reduce((sum, p) => {
        const price = p.price || 0;
        const qty = p.quantity || 0;
        const gstRate = p.gst || 0;
        return sum + (price * qty * gstRate) / 100;
      }, 0)
      .toFixed(2);

    const rePrintPayload = {
      products,
      totalGstPrice,
      total_amount: Number(order.total),
      discount_price: Number(order.discount_price || 0),
      payment_method: order.paymentMethod,
      customer_phone: order.customer_phone || "Guest",
      customer_name: order.customer_name || "Guest",
    };

    const invoiceName = "TAX INVOICE COPY";

    const receiptContent = generateReceipt(
      rePrintPayload,
      billIconBase64,
      order.invoice_number,
      order.user_name,
      order.order_date,
      order.order_time,
      userLoginStatus,
      invoiceName
    );

    handlePrint(receiptContent);
  };

  return (
    <Box
      sx={{
        width: "99vw",
        height: "94vh",
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: "95%", mt: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            height: 64,
            minHeight: 64,
            background: "#fff",
            borderRadius: 3,
            boxShadow:
              "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
            // boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            px: 3,
            mb: 2,
            position: "relative",
          }}
        >
          <ShoppingCartIcon sx={{ fontSize: 36, color: "#0072ff" }} />
          <Typography
            variant="h5"
            fontWeight={800}
            color="#222"
            sx={{ lineHeight: 1 }}
          >
            Cashier Billings
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          {orderMesg && (
            <Typography sx={{ color: "green", fontSize: "0.9rem" }}>
              {orderMesg}
            </Typography>
          )}
          {orderErrMesg && (
            <Typography sx={{ color: "red", fontSize: "0.9rem" }}>
              {orderErrMesg}
            </Typography>
          )}

          <AccentButton
            sx={{
              background: "linear-gradient(90deg, #4e54c8 0%, #8f94fb 100%)",
            }}
            onClick={() => navigate("/cashier_billing_panel")}
          >
            Go to billing
          </AccentButton>

          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                height: 40,
                bgcolor: "#f47920",
                color: "#fff",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                pr: 1,
                cursor: "pointer",
              }}
              onClick={(e) => handleAvatarClick(e)}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: "navy",
                  color: "#fff",
                  borderRadius: "50%",
                  border: "3px solid white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                  fontSize: 22,
                }}
              >
                {userLoginStatus?.role?.slice(0, 1).toUpperCase()}
              </Box>
              {userLoginStatus?.role?.slice(1)}
            </Box>

            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                sx: { p: 2, minWidth: 220, borderRadius: 3 },
              }}
            >
              <Typography fontWeight="bold" fontSize="1rem" mb={0.5}>
                {userLoginStatus.username}
              </Typography>
              <Typography fontWeight="bold" fontSize="1rem" mb={0.5}>
                {userLoginStatus.email}
              </Typography>
              <Typography fontSize="0.9rem" color="text.secondary" mb={1}>
                Role: {userLoginStatus.role}
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Button
                fullWidth
                variant="text"
                color="error"
                onClick={onLogoutClick}
                sx={{
                  justifyContent: "flex-start",
                  textTransform: "none",
                  fontWeight: "bold",
                }}
                startIcon={<span style={{ fontSize: 18 }}>↩</span>}
              >
                Log out
              </Button>
            </Popover>
          </Box>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            {loading ? (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    <CircularProgress color="primary" />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#0d3679",
                    }}
                  >
                    <TableCell />
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      S No
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Invoice No
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Customer
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Mobile
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Order Date
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Payment
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Discount
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Total
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Cashier
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders.map((order) => (
                    <Row
                      key={order.order_id}
                      order={order}
                      onPrintReceipt={onPrintReceipt}
                    />
                  ))}
                </TableBody>
              </>
            )}
          </Table>
          <TablePagination
            component="div"
            count={rowCount}
            page={paginationModel.page}
            onPageChange={(_e, newPage) =>
              setPaginationModel((prev) => ({ ...prev, page: newPage }))
            }
            rowsPerPage={paginationModel.pageSize}
            onRowsPerPageChange={(event) => {
              const newSize = parseInt(event.target.value, 10);
              setPaginationModel({ page: 0, pageSize: newSize });
            }}
            rowsPerPageOptions={[10, 25, 50]}
          />
        </TableContainer>
        {rowCount < 10 ? <Box p={2} /> : <Box p={8} />}
      </Box>
    </Box>
  );
}

export default CashierBillings;
